import { call, put } from 'redux-saga/effects';
import CancelMakeActions from '../redux/CancelMakeRedux';
import { api } from './api';


export function* cancelmakesagas(action: any): Generator<any, void, any> {
  const { make_id } = action;
  const response = yield call(api.cancelMake, make_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(CancelMakeActions.cancelMakeSuccess(response.data));
  } else {
    yield put(CancelMakeActions.cancelMakeFailure());
  }
}